import { qnBlueGrey } from '../themes/_palette';

export const MuiButton = {
    styleOverrides: {
        root: {
            textTransform: 'none',
            borderRadius: 8,
            boxShadow: 'none',
            whiteSpace: 'nowrap',
            background: '#fff',
            fontWeight: 'bold',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            "&.Mui-disabled": {
                color: 'var(--mui-palette-texts-darkIcons)',
                backgroundColor: qnBlueGrey[100],
                '&:hover':{
                    backgroundColor: qnBlueGrey[100],
                }
            }
        },
        startIcon: {
            "& > svg:first-of-type": {
                fontSize: '1.375rem'
            }
        },
        contained: {
            "&.Mui-disabled": {
                color: 'var(--mui-palette-texts-darkIcons)',
                backgroundColor: qnBlueGrey[100],
                '&:hover':{
                    backgroundColor: qnBlueGrey[100],
                }
            }
        }

    }
}
